import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CartMatchOffer from './CartMatchOffer';
import FormattedCurrency from '@s/FormattedCurrency';
import Translation from '@s/Translation';

/**
 * Price of all items in a cart match offer grouped
 * Shows discounted vs original if discounted price lower
 */
class CartMatchPrice extends Component {

    render() {

        let price = 0;
        let discountedPrice = 0;

        this.props.details.forEach(detail => {
            if (CartMatchOffer.isValidDetail(detail)) {
                let priceLevel = null;
                this.props.priceLevels.forEach(pl => {
                    if (+pl.price_level_id === +detail.id) {
                        priceLevel = pl;
                    }
                });
                if (priceLevel && typeof priceLevel === 'object') {
                    const plPrice = priceLevel?.price?.price ?? 0;
                    const plServiceFee = priceLevel?.service_fee?.price ?? 0;
                    const plDiscountedPrice = priceLevel?.discounted_price?.price ?? 0;
                    const plDiscountedServiceFee = priceLevel?.discounted_service_fee?.price ?? 0;
                    price += (detail.count * (plPrice + plServiceFee));
                    discountedPrice += (detail.count * (plDiscountedPrice + plDiscountedServiceFee));
                }
            }
        })

        if (discountedPrice >= price) {
            return (
                <div className="ticket__price">
                    <FormattedCurrency>{ price }</FormattedCurrency>
                </div>
            );
        }
        return (
            <div className="ticket__price">
                <div className="upsell__price-match__original-price">
                    <s><span className="sr-only"><Translation>{'checkout__former_price'}</Translation></span><FormattedCurrency>{ price }</FormattedCurrency></s>
                </div>
                <div className="upsell__price-match__discounted-price">
                    <span className="sr-only"><Translation>{'checkout__discount_price'}</Translation></span>
                    <FormattedCurrency>{ discountedPrice }</FormattedCurrency>
                </div>
            </div>
        );
    }
}

CartMatchPrice.propTypes = {
    details: PropTypes.array.isRequired,
    priceLevels: PropTypes.array.isRequired,
};

export default CartMatchPrice;
